import React, { useState } from 'react';
import { ContractList } from './ContractList';
import { ContractForm } from './ContractForm';
import { ContractTypes } from './ContractTypes';
import { ContractVariations } from './ContractVariations';
import { ContractAmendments } from './ContractAmendments';
import { ContractMilestones } from './ContractMilestones';
import { ContractPaymentClaims } from './ContractPaymentClaims';
export function ContractManagement({
  locale,
  currentView,
  setCurrentView
}) {
  const [selectedContract, setSelectedContract] = useState(null);
  // Determine which component to render based on the current view
  const renderContent = () => {
    switch (currentView) {
      case 'contract-types':
        return <ContractTypes locale={locale} data-id="element-2529" />;
      case 'add-contract':
        return <ContractForm locale={locale} onSelectContract={setSelectedContract} data-id="element-2530" />;
      case 'contract-detail':
        return <ContractList locale={locale} onSelectContract={setSelectedContract} data-id="element-2531" />;
      case 'contract-variations':
        return <ContractVariations locale={locale} data-id="element-2532" />;
      case 'contract-amendments':
        return <ContractAmendments locale={locale} data-id="element-2533" />;
      case 'contract-milestones':
        return <ContractMilestones locale={locale} data-id="element-2534" />;
      case 'contract-payment-claims':
        return <ContractPaymentClaims locale={locale} data-id="element-2535" />;
      case 'contract-management':
        // Default dashboard view
        return <div data-id="element-2536">
            <div className="mb-8" data-id="element-2537">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-2538">
                Contract Management
              </h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-2539">
                Manage all aspects of your contracts, from creation to
                completion
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2540">
              {/* Quick access cards */}
              <div onClick={() => setCurrentView('contract-detail')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2541">
                <div className="p-5" data-id="element-2542">
                  <div className="flex items-center" data-id="element-2543">
                    <div className="flex-shrink-0 bg-indigo-500 rounded-md p-3" data-id="element-2544">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2545">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-2546" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2547">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2548">
                        Contract List
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2549">
                        View and manage all contracts
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('add-contract')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2550">
                <div className="p-5" data-id="element-2551">
                  <div className="flex items-center" data-id="element-2552">
                    <div className="flex-shrink-0 bg-green-500 rounded-md p-3" data-id="element-2553">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2554">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-2555" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2556">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2557">
                        Add Contract
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2558">
                        Create a new contract
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-variations')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2559">
                <div className="p-5" data-id="element-2560">
                  <div className="flex items-center" data-id="element-2561">
                    <div className="flex-shrink-0 bg-purple-500 rounded-md p-3" data-id="element-2562">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2563">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" data-id="element-2564" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2565">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2566">
                        Variations
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2567">
                        Manage contract variations
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-amendments')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2568">
                <div className="p-5" data-id="element-2569">
                  <div className="flex items-center" data-id="element-2570">
                    <div className="flex-shrink-0 bg-yellow-500 rounded-md p-3" data-id="element-2571">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2572">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" data-id="element-2573" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2574">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2575">
                        Amendments
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2576">
                        Track contract amendments
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-milestones')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2577">
                <div className="p-5" data-id="element-2578">
                  <div className="flex items-center" data-id="element-2579">
                    <div className="flex-shrink-0 bg-blue-500 rounded-md p-3" data-id="element-2580">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2581">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" data-id="element-2582" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2583">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2584">
                        Milestones
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2585">
                        Track contract milestones
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-payment-claims')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2586">
                <div className="p-5" data-id="element-2587">
                  <div className="flex items-center" data-id="element-2588">
                    <div className="flex-shrink-0 bg-red-500 rounded-md p-3" data-id="element-2589">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2590">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-2591" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2592">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2593">
                        Payment Claims
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2594">
                        Manage payment claims
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-types')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2595">
                <div className="p-5" data-id="element-2596">
                  <div className="flex items-center" data-id="element-2597">
                    <div className="flex-shrink-0 bg-gray-500 rounded-md p-3" data-id="element-2598">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2599">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-2600" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2601">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2602">
                        Contract Types
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2603">
                        Manage contract types
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      default:
        return <ContractList locale={locale} onSelectContract={setSelectedContract} data-id="element-2604" />;
    }
  };
  return <div data-id="element-2605">
      {selectedContract ? <ContractForm locale={locale} contract={selectedContract} onSelectContract={setSelectedContract} data-id="element-2606" /> : renderContent()}
    </div>;
}